/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Field_PosterInputs */

const vi_media_field_poster = /** @type {(inputs: Media_Field_PosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh bìa`)
};

/**

* @param {Media_Field_PosterInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_field_poster = /** @type {((inputs?: Media_Field_PosterInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Field_PosterInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_field_poster(inputs)
});